import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import FormField from '@ui/formfield/FormField';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import NewsletterErrorModal from './NewsletterErrorModal';
import NewsletterForm from './NewsletterForm';
import classNames from 'classnames';
const Newsletter = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [modalErrorMessage, setModalErrorMessage] = useState();
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [showSubModal, setShowSubModal] = useState(false);
    const [email, setEmail] = useState('');
    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    const onSubmit = async (values) => {
        setErrors([]);
        if (validateEmail(values.nlField)) {
            const isNewEmail = await api.checkNewsletterEmail(values.nlField);
            if (isNewEmail.success) {
                setEmail(values.nlField);
                setShowSubModal(true);
                //check if we are on monclernow listing
                if (props.isMonclernowModule) {
                    analytics.newsletterModuleContinue();
                }
                else {
                    analytics.footerSection(props.footerSectionTitle, t('button.continue'));
                }
            }
            else {
                setModalErrorMessage({
                    title: t('newsletter.alreadyregisteredtitle'),
                    body: t('newsletter.alreadyregisteredtext'),
                    buttonLink: '/',
                    buttonText: t('newslettermodal.continue'),
                });
            }
        }
        else {
            setErrors([t('forgotpassword.invalidemail')]);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Form, { onSubmit: onSubmit, render: ({ handleSubmit }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "row justify-center" },
                    React.createElement("div", { className: "col-12 newsletter-container" },
                        React.createElement(FormField, { className: classNames({ 'form-control--outline': !props.isFooter }), labelClassName: classNames('form-group__label', { 'form-group__label--floating': !props.isFooter }), name: "nlField", label: t('footer.email.address'), type: "email", autocomplete: "email", required: true, placeholder: t('footer.newsletter.placeholder') }),
                        React.createElement(ErrorBox, { errors: errors, className: "mt-20" }),
                        props.isFooter ? (React.createElement("button", { type: "submit", "aria-label": t('button.continue') },
                            React.createElement("i", { className: "icon--chevron-small-right", "aria-hidden": true }))) : (React.createElement(Button, { type: "submit", cls: ['button--secondary'] }, t('button.continue'))))))) }),
        React.createElement(NewsletterErrorModal, { isOpen: Boolean(modalErrorMessage === null || modalErrorMessage === void 0 ? void 0 : modalErrorMessage.title), modalErrorMessage: modalErrorMessage, onRequestClose: setModalErrorMessage }),
        React.createElement(ModalDialog, { className: "newsletter-modal newsletter-modal--subscription-modal", isOpen: showSubModal, contentLabel: "Newsletter subscription", onRequestClose: () => {
                analytics.newsletterCloseModal();
                setShowSubModal(false);
            } },
            React.createElement("div", { className: "newsletter-modal__columns-wrapper" },
                React.createElement("div", { className: "newsletter-modal__img-container" },
                    React.createElement("img", { src: props.image, alt: "" })),
                React.createElement("div", { className: "newsletter-modal__text-holder" }, submitSuccess ? (React.createElement("div", { className: "modal__header-sticky" },
                    React.createElement("h2", { className: "newsletter-modal__title", role: "alert" }, t('newslettermodal.successtitle')),
                    React.createElement("p", { className: "newsletter-modal__description" },
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: t('newslettermodal.successdescription') } }),
                        React.createElement("a", { href: window.homeurl, className: "button button--primary" }, t('newslettermodal.continue'))))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "modal__header-sticky" },
                        React.createElement("h2", { className: "newsletter-modal__title" }, t('newslettermodal.title')),
                        React.createElement("p", { className: "newsletter-modal__description" },
                            React.createElement("span", null, t('newslettermodal.description')))),
                    React.createElement(NewsletterForm, { email: email, cookiepage: props.cookiepage, onSubmitSuccess: () => {
                            setSubmitSuccess(true);
                        } }))))))));
};
export default Newsletter;
